// 已领取
export const RECEIVED_STATUS = 1;
// 未领取
export const UNRECEIVE_STATUS = 0;
// 未开始
export const NO_START_STATUS = -1;
// 发放成功
export const DISTRIBUTED = 1;
// 发放中
export const DISTRIBUTING = 0;
// 发放失败
export const DISTRIBUT_FIAL = 3;
// 服务失败
export const SERVICE_FIAL = 4;

export const DISTRIBUTION_TEXT_MAP = {
  [DISTRIBUTING]: '发放中',
  [DISTRIBUTED]: '发放成功',
  [DISTRIBUT_FIAL]: '发放中',
  [SERVICE_FIAL]: '发放中',
};

export const ACTION_TEXT_MAP = {
  [DISTRIBUTING]: '--',
  [DISTRIBUTED]: '去使用',
  [DISTRIBUT_FIAL]: '--',
  [SERVICE_FIAL]: '--',
};

export const BTN_TEXT_MAP = {
  [NO_START_STATUS]: '7月4日 11点 开始领取',
  [RECEIVED_STATUS]: '已领取',
  [UNRECEIVE_STATUS]: '点击领取',
};

export const BTN_CLASSNAME_MAP = {
  [NO_START_STATUS]: '',
  [RECEIVED_STATUS]: 'received',
  [UNRECEIVE_STATUS]: 'unreceive',
};

export const GIFT_FLM = 'flm';
export const GIFT_YOUZAN = 'youzan';
